export const blogTranslations={
  blog_screen_title: "Quality Nexus blog ",
  blog_screen_descrition: "Insights, best practices, and industry trends in software testing and quality assurance",
  blog_search_bar:"search articles toppics or tags",
  next: "Next",
  previous: "Previous",
  show_less: "Show Less",
  blog_read_more: "Read more",
  blog_showing_filtered: "Showing {{count}} of {{total}} articles in {{category}}{{search}}",
  blog_showing_all: "Showing {{count}} of {{total}} articles{{search}}",
  blog_search_term: " for \"{{term}}\"",
  show_all_categories: "Show All Categories",
  no_blog_posts_found: "No blog posts match this filter.",
  noArticles_title: "No articles found",
  noArticles_description: "Try adjusting your search terms or browse different categories",
  noArticles_clearButton: "Clear Filters",
  blog_categories: {
    all: "All",
    backToBlog: "Back to Blog",
    browseByCategory: "Browse by Category",
    introText: "Find articles specific to your testing interests and expertise",
    searchPlaceholder: "Search articles, topics, or tags...",
    categories: "Categories",
    filterDescription: "Filter articles by topic",
    categoryFilterPlaceholder: "Filter categories...",
  },
  newsletter: {
      title: "stay updated " ,
      description: "Subscribe to our newsletter to get the latest insights on software testing and quality assurance delivered to your inbox.",
      emailPlaceholder:"enter your email",
      subscribe: "subscribe "
    },
 };